/**
 * @generated SignedSource<<0b9a008acbff56e0d4955024a9dc874c>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type Labels_team$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type MemberTeamRow_team$fragmentType: FragmentType;
export type MemberTeamRow_team$data = {|
  +description: ?string,
  +id: string,
  +name: string,
  +uuid: string,
  +$fragmentSpreads: Labels_team$fragmentType,
  +$fragmentType: MemberTeamRow_team$fragmentType,
|};
export type MemberTeamRow_team$key = {
  +$data?: MemberTeamRow_team$data,
  +$fragmentSpreads: MemberTeamRow_team$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberTeamRow_team",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Labels_team"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node/*: any*/).hash = "c193386ac490daed9b43d9749360f6fd";

module.exports = ((node/*: any*/)/*: Fragment<
  MemberTeamRow_team$fragmentType,
  MemberTeamRow_team$data,
>*/);
